<template>
  <section class="caseBase">
    <div class="tags t_center f24 grey9">
      <ul class="tag-cont" :class='{lookmore:tagLookMore}'>
        <li v-for="(item,index) in tags" :key="index" :class='{active:tagActive == index}' @click='choseTag(index)'>{{item.name=='全部'?'全部(' + allNum + ')':item.name}}</li>
      </ul>
      <p @click='tagLookMore = !tagLookMore'><span>{{tagLookMore?"收起":"查看更多"}}</span>
      
      <van-icon name="arrow-down" v-show='!tagLookMore'/>
      <van-icon name="arrow-up" v-show='tagLookMore'/>
      </p>
    </div>
    <van-list 
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getExit">
      <ul class="caseList">
        <li v-for="(item,index) in Extlist" :key="index">
          <div class="topWrap">
            <time class="grey9 r f24">{{item.createTimeFormat}}</time>
            <div>
              <img class="l" :src="item.headImgUrl" alt="">
              <h3 class="grey6 f28">{{item.customerName}}</h3>
            </div>
          </div>
          <div class="midWrap">
            <h4 class="f32">{{item.symptomName}}</h4>
            <div class="picArr">
              <img  :src="formatImgUrl(item.beforePic,300,300,true)" alt=""  @click='preview(0,[item.beforePic,item.afterPic])'>
              <img  :src="formatImgUrl(item.afterPic,300,300,true)" alt=""  @click='preview(0,[item.beforePic,item.afterPic])'>
            </div>
          </div>
          <div class="botWrap t_right">
            <span>{{item.attentionCount}}</span><span class="zan" :class='{active:item.zan}' @click='zan(item,index)'>{{item.zanCount}}</span>
          </div>
        </li>
      </ul>
    </van-list>

    <div class="filterBtn" @click="$refs.filterPopup.show()" :class='{scrolling:scroll}'>
      <img src="/images/home/filter_icon.png" alt="">
    </div>
    <filter-popup ref="filterPopup" :categoryId='categoryId' :catogoryList='tags' @submitSearch='submitSearch' :serviceId='serviceId'></filter-popup>
    <previewer ref="previewer"></previewer>
  </section>
</template>

<script>
  import filterPopup from './filterPopup'
  import caseApi from '@/axios/case'
  import zhugeObj from '@/assets/js/track';
  let timerout;
  export default {
    name: 'caseBase',
    components: {
      filterPopup
    },
    data () {
      return {
        loading : false,
        finished : false,
        canMore : true,
        queryCategoryId : '',
        queryBrandId : '',
        queryColorId : '',
        queryMaterialId : '',
        page : {
          current : 1,
          size : 5,
        },
        tagLookMore : false,
        tagActive : 0,
        tags: [
          
        ],
        caseList: [
          {}
        ],
        Extlist : [],
        allNum : '',
        scroll:false,
        totleFlag : false,
      }
    },
    props: {
      categoryId: {
        type: Number
      },
      serviceId : {
        type : String,
        default : ''
      },
      sid : {
        type : Number,
        default : null
      },
      
    },
    watch: {},
    computed: {},
    created () {
      this.getCategoryList();
      this.getExit();
      // this.getallnum();
    },
    mounted() {
      window.addEventListener('scroll', this.menu)
    },
    methods: {
      zan(item,index){
        zhugeObj.track({
          title : '案例',
          content : {
            '点赞' : item.id
          }
        })
      
        if(item.zan){
          caseApi.unexactZan(item.id).then((res)=>{
            this.Extlist[index].zan = !this.Extlist[index].zan;
            this.Extlist[index].zanCount--;
          })
        }else{
          caseApi.exactZan(item.id).then((res)=>{
            this.Extlist[index].zan = !this.Extlist[index].zan;
            this.Extlist[index].zanCount++;
          })
        }   
      },
      preview(index,list){
        this.$refs.previewer.show(index, list, ['修复前','修复后'])
      },
      menu(){
        let _this = this;
        this.scroll = true;
        if(timerout){
          window.clearTimeout(timerout);
        }
        
        timerout = setTimeout(()=>{
          _this.scroll = false;
        },500)
      },
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      submitSearch(data){
        this.queryCategoryId = data.queryCategoryId;
        this.queryBrandId = data.queryBrandId;
        this.queryColorId = data.queryColorId;
        this.queryMaterialId = data.queryMaterialId;
        this.page.current = 1;
        this.finished = false;
        this.Extlist = [];
        this.getExit();
      },
      choseTag(index){
        this.tagActive = index;
        this.queryCategoryId = this.tags[index].id;
        this.queryBrandId = '';
        this.queryColorId = '';
        this.queryMaterialId = '';
        this.page.current = 1;
        this.finished = false;
        this.Extlist = [];
        this.getExit();
      },
      getExit(){
        if(!this.canMore){
          return;
        }
        this.canMore = false;
        this.loading = true;
   
        let params = {
          brandId : this.queryBrandId,
          colorId : this.queryColorId,
          materialId : this.queryMaterialId,
          current : this.page.current,
          size : this.page.size,
          serviceId : this.sid
        };
        //6以上是2级品类
        if(this.queryCategoryId){
          if(this.queryCategoryId > 6){
            params.categoryId = this.queryCategoryId
          }else{
            params.firstLevelCategoryId = this.queryCategoryId
          }
        }

        caseApi.getExact(params).then((res)=>{
          zhuge.track('查看服务详情', {
            '案例库筛选' : '案例库筛选'
          })
          this.Extlist = this.Extlist.concat(...res.records || []);
          this.canMore = true;
          if(res.totalPage == this.page.current || res.totalPage == 0){
              this.finished = true;
          }
          if(res.records.length == 0){
              this.finished = true;
          }
          this.loading = false;
          this.page.current++;
          if(!this.totleFlag){
            this.allNum = res.total;
          }
          this.totleFlag = true;
          // this.allNum = res.total;
        })
      },
      getallnum(){
        let params = {
          serviceId : this.sid
        }
        caseApi.getExact(params).then((res)=>{
          this.allNum = res.total;
        })
      },
      getCategoryList(){
        let params = {
          parentId : this.categoryId
        }

        caseApi.getScendCatogery(params).then((res)=>{
          res.unshift({
            id : '',
            name : '全部'
          });
          this.tags = res;
        })
      }

    }

  }
</script>

<style lang="scss" scoped>
  .lookmore{
    height: auto!important;
  }
  .tag-cont{
    height: 140px;
    overflow: hidden;
  }
  .caseBase{
    .tags{
      padding: 20px 0 28px 30px;
      border-bottom: 20px #f6f6f6 solid;
      ul{
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 18px;
        li{
          min-width:156px;
          height:54px;
          line-height: 52px;
          box-sizing: border-box;
          padding:0 27px ;
          background:#f8f8f8;
          border-radius:28px;
          text-align: center;
          border:1px solid #E9E9E9;
          margin: 0 20px 30px 0;
          &.active{
            color:#7ADFDF;
            background:rgba(121,207,207,0.1);
            border:1px solid rgba(122,223,223,1);
          }
        }
      }
      p{
        line-height: 34px;
        span{margin-right: 14px}
        span,.van-icon{vertical-align: middle}
      }
    }
    .caseList{
      padding: 30px 30px 0;
      li{
        margin-bottom: 50px;
        border-bottom: $base-border;
        .topWrap{
          height: 66px;
          line-height: 66px;
          margin-bottom: 30px;
          img{
            width: 66px;
            height:66px;
            margin-right: 20px;
            border-radius: 50%;
          }
        }
        .midWrap{
          margin-bottom: 24px;
          h4{
            line-height: 44px;
            margin-bottom: 24px;
          }
          .picArr{
            display: flex;
            justify-content: space-between;
            img{
              width: 336px;
              height: 240px;
            }
          }
        }
        .botWrap{
          height: 40px;
          line-height: 40px;
          margin-bottom: 30px;
          span{
            display: inline-block;
            margin-left: 76px;
            padding-left: 48px;
            background: url("/images/case/case_item_icon01.png") no-repeat left center;
            background-size: 42px;
          }
          .zan{
            background-image: url("/images/case/case_item_icon02.png") ;
          }
          .zan.active{
            background-image: url("/images/case/case_item_icon03.png") ;
            color: $brand-color;
          }
        }
      }
    }

    .filterBtn{
      position: fixed;
      right: 0;
      bottom: 150px;
      width: 134px;
      height: 122px;
      transition: all 0.5s ease;
      -webkit-transition: all  0.5s ease;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }

  .scrolling{
    right:-135px!important; 
    transition: all 0.5s ease;
    -webkit-transition: all  0.5s ease;
  }
</style>
